<template>
  <div class="check-content pa-0">
    <!-- menu superior -->
    <v-layout column class="menu w-100 white" v-if="showMap">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/usecargobranco.png`)"
            alt="pickndrive"
            style="width: auto; height: 39px"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <div
      v-if="stepName == 'Check-in' && showMap"
      class="vehicleMap text-center white content pa-0 w-100"
    >
      <p
        class="titleMap title pb-3 font-weight-medium colorCheckin"
        style="width: 80%; margin: auto"
      >
        Dirija-se até o veículo:
      </p>

      <googleMapsMarkers
        style="max-height: 55vh; width: 80%"
        :longitude="configurations.longitude_visualization.value"
        :latitude="configurations.latitude_visualization.value"
        :type="'check-in'"
      ></googleMapsMarkers>

      <v-btn
        class="btn-sucess mt-3"
        @click="showMap = !showMap"
        :disabled="blockNext"
      >
        <span class="white--text" style="text-transform: none"
          >PRÓXIMA ETAPA</span
        >
      </v-btn>

      <!-- Modal check-out pendente -->
      <modal
        :showModal="ifCheckOut"
        :ifTitle="true"
        :Title="'Check-out pendente'"
        :ifSubheadingBottom="true"
        :SubheadingBottom="'Você têm que finalizar o check-out antes de fazer um novo check-in.'"
        :ifIcon="true"
        :Icon="'pause'"
        :ifOneBtn="true"
        :TextOneBtn="'Ok'"
        @btnUm="$router.push({ name: 'driver-vehicle-request-dashboard' })"
      ></modal>
    </div>

    <!-- Modal feedback -->
    <div class="feedback-screen" v-if="feedbackShow">
      <feedback
        :idVehicleRequest="vehicleRequestId"
        @changeDialog="
          $router.push({ name: 'driver-vehicle-request-dashboard' })
        "
        @addProgress="changeProgress($event)"
      ></feedback>
    </div>

    <!-- alertas -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Modal as portas abriram -->
    <modal
      :showModal="dialogDoors"
      :ifTitle="true"
      :Title="'As portas do carro abriram?'"
      :ifIcon="true"
      :Icon="'lock_open'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="changeDoors('unlock')"
      @btnDois="(modalChaves = !modalChaves), (dialogDoors = !dialogDoors)"
    ></modal>

    <!-- Modal bluetooth -->
    <modal
      :showModal="dialogBluetooth"
      :ifSubheadingTop="true"
      :SubheadingTop="'Deseja abrir as portas com o bluetooth do seu aparelho?'"
      :ifTitle="true"
      :Title="'Abrir com bluetooth'"
      :ifIcon="true"
      :Icon="'bluetooth'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="dialogBluetooth = false"
      @btnDois="openBluetoothPage()"
    ></modal>

    <!-- Modal Chaves -->
    <modal
      :showModal="modalChaves"
      :ifTitle="true"
      :Title="'A chave está dentro do porta-luvas'"
      :ifIcon="true"
      :Icon="'vpn_key'"
      :ifOneBtn="true"
      :TextOneBtn="'Ok'"
      @btnUm="$router.push({ name: 'driver-vehicle-request-dashboard' })"
    ></modal>

    <!-- Modal Loading -->
    <v-dialog persistent max-width="300" v-model="blockscreen">
      <v-card class="px-3 py-5 text-center">
        <div class="text-center pb-5">
          <span class="title font-weight-bold"
            >Aguarde, estamos processando os dados...</span
          >
        </div>
        <v-progress-circular
          :size="70"
          :width="7"
          class="colorCheckin"
          indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>

    <!-- Modal chaves check-out-->
    <modal
      :showModal="keysCheck"
      :ifTitle="true"
      :Title="'A chave ainda está com você?'"
      :ifSubheadingBottom="true"
      :SubheadingBottom="'Não se esqueça de deixá-la dentro do porta-luvas.'"
      :ifIcon="true"
      :Icon="'vpn_key'"
      :ifOneBtn="true"
      :TextOneBtn="'Ok'"
      @btnUm="keysCheck = !keysCheck"
    ></modal>

    <!-- Modal está dentro do carro-->
    <modal
      :showModal="exitCar"
      :ifTitle="true"
      :Title="'Você ainda está dentro do carro?'"
      :ifSubheadingBottom="true"
      :SubheadingBottom="'Se estiver dentro do carro, saia e feche a porta para podermos realizar o trancamento.'"
      :ifIcon="true"
      :Icon="'warning'"
      :ifOneBtn="true"
      :TextOneBtn="'trancar o carro'"
      @btnUm="newRegister(), (exitCar = !exitCar), changeProgress(15)"
    ></modal>

    <!-- Modal as portas fecharam -->
    <modal
      :showModal="lockCar"
      :ifTitle="true"
      :Title="'As portas do carro trancaram?'"
      :ifIcon="true"
      :Icon="'lock'"
      :ifTwoBtn="true"
      :TextFirstBtn="'Não'"
      :TextSecondBtn="'Sim'"
      @btnUm="changeDoors('lock')"
      @btnDois="
        (feedbackShow = !feedbackShow),
          (lockCar = false),
          (damageScreen = false)
      "
    ></modal>

    <div
      class="check-background white content"
      v-if="load_stepContent && (!showMap || stepName == 'Check-out')"
    >
      <!--Header-->
      <v-card elevation="0" class="step-header">
        <v-btn text @click="backScreen()" :disabled="feedbackShow"
          ><v-icon medium>mdi-chevron-left</v-icon></v-btn
        >
        {{ stepName }}
        <v-progress-linear
          class="mt-1"
          color="var(--primary-color)"
          :value="progress"
        ></v-progress-linear>
      </v-card>

      <!--Registro de danos-->
      <v-container class="register-content" v-if="damageScreen">
        <div v-if="!checkoutScreen">
          <div class="title pb-1">Registro de danos</div>
          <div class="damage-registry pb-2">
            Verifique as condições de uso do carro e, em caso de danos, adicione
            fotos do local.
          </div>
          <div class="damage-registry">
            Na falta do registro, entenderemos que o veículo está em perfeitas
            condições de uso.
          </div>
        </div>
        <div v-else>
          <div class="title pb-1">Registro de devolução do veículo.</div>
          <div class="damage-registry pb-2">
            Adicione a foto de cada local solicitado para continuar com o
            check-out.
          </div>
          <div class="damage-registry">
            Ao tirar as fotos, fique atento e assegure que elas estão corretas.
            Lembre-se, elas poderão ser usadas como comparativo para eventuais
            cobranças de avarias, se encontradas.
          </div>
        </div>

        <v-container class="info-container">
          <v-layout>
            <v-flex xs2>
              <v-icon color="var(--primary-color)" size="55"
                >mdi-car-outline</v-icon
              >
            </v-flex>
            <v-flex pl-3>
              <v-layout>Modelo {{ vehicle.brand }}</v-layout>
              <v-layout class="grey--text">Placa {{ vehicle.plate }} </v-layout>
            </v-flex>
          </v-layout>
          <v-layout v-if="identifyAndroid()" row class="buttons-container">
            <v-row>
              <v-btn
                outlined
                :disabled="isAnswered(4)"
                :class="stepColor[4] ? 'damage-button-check' : 'damage-button'"
                @click="btnF = true,capture(stepContent[4])"
                ><span>Frente</span>
                <v-avatar
                  v-if="stepColor[4]"
                  color="var(--secondary-color)"
                  size="20px"
                  class="button-chip"
                >
                  {{ avatarNumbersF }}
                </v-avatar>
              </v-btn>
              <v-btn
                outlined
                :disabled="isAnswered(3)"
                :class="stepColor[3] ? 'damage-button-check' : 'damage-button'"
                @click="btnLd = true, capture(stepContent[3])"
                ><span>Lateral direita</span>
                <v-avatar
                  v-if="stepColor[3]"
                  color="var(--secondary-color)"
                  size="20px"
                  class="button-chip"
                >
                  {{ avatarNumbersLd }}
                </v-avatar>
              </v-btn>
            </v-row>
            <v-row>
              <v-btn
                outlined
                :disabled="isAnswered(2)"
                :class="stepColor[2] ? 'damage-button-check' : 'damage-button'"
                @click="btnT = true, capture(stepContent[2])"
                ><span>Traseira</span>
                <v-avatar
                  v-if="stepColor[2]"
                  color="var(--secondary-color)"
                  size="20px"
                  class="button-chip"
                >
                  {{ avatarNumbersT }}
                </v-avatar>
              </v-btn>
              <v-btn
                outlined
                :disabled="isAnswered(1)"
                :class="stepColor[1] ? 'damage-button-check' : 'damage-button'"
                @click="btnLe = true, capture(stepContent[1])"
                ><span>Lateral esquerda</span>
                <v-avatar
                  v-if="stepColor[1]"
                  color="var(--secondary-color)"
                  size="20px"
                  class="button-chip"
                >
                  {{ avatarNumbersLe }}
                </v-avatar>
              </v-btn>
            </v-row>

            <v-row>
              <v-btn
                v-if="checkoutScreen"
                outlined
                :disabled="isAnswered(0)"
                :class="stepColor[0] ? 'damage-button-check' : 'damage-button'"
                @click="btnE = true, capture(stepContent[0])"
                ><span>Estepe</span>
                <v-avatar
                  v-if="stepColor[0]"
                  color="var(--secondary-color)"
                  size="20px"
                  class="button-chip"
                >
                  {{ avatarNumbersE }}
                </v-avatar>
              </v-btn>
            </v-row>
          </v-layout>

          <!--input default-->
          <v-layout v-if="!identifyAndroid()" row class="buttons-container">
            <v-flex>
              <v-file-input
                :disabled="isAnswered(4)"
                chips
                multiple
                accept="image/*"
                prepend-icon="mdi-camera"
                label="Frente"
                @change="onFileSelected"
                @click="e1 = 4"
              ></v-file-input>
              <v-file-input
                :disabled="isAnswered(3)"
                chips
                multiple
                accept="image/*"
                prepend-icon="mdi-camera"
                label="Lateral direita"
                @change="onFileSelected"
                @click="e1 = 3"
              ></v-file-input>
            </v-flex>
            <v-flex>
              <v-file-input
                :disabled="isAnswered(2)"
                chips
                multiple
                accept="image/*"
                prepend-icon="mdi-camera"
                label="Traseira"
                @change="onFileSelected"
                @click="e1 = 2"
              ></v-file-input>
              <v-file-input
                :disabled="isAnswered(1)"
                chips
                multiple
                accept="image/*"
                prepend-icon="mdi-camera"
                label="Lateral esquerda"
                @change="onFileSelected"
                @click="e1 = 1"
              ></v-file-input>
            </v-flex>
            <v-flex>
              <v-file-input
                :disabled="isAnswered(0)"
                chips
                multiple
                accept="image/*"
                prepend-icon="mdi-camera"
                v-if="checkoutScreen"
                label="Estepe"
                @change="onFileSelected"
                @click="e1 = 0"
              ></v-file-input>
            </v-flex>
          </v-layout>
          <!--Carro sem danos-->
          <v-switch
            class="pl-3 damage-switch"
            inset
            v-if="!checkoutScreen"
            :disabled="stepPhotos > 0"
            label="Carro sem danos"
            color="var(--secondary-color)"
            v-model="notDamaged"
          ></v-switch>

          <div class="text-center pt-3">
            <v-btn
              :disabled="stepPhotos == 0 && notDamaged == false"
              color="var(--secondary-color)"
              width="90%"
              v-if="!checkoutScreen"
              class="white--text"
              @click="nextScreen"
              >CONTINUAR</v-btn
            >
            <!--continuar checkout-->
            <v-btn
              :disabled="stepPhotos < 5"
              color="var(--secondary-color)"
              v-else
              width="90%"
              class="white--text"
              @click="nextScreen"
              >CONTINUAR</v-btn
            >
          </div>
        </v-container>
      </v-container>

      <!--Tela de selfie-->
      <div
        class="check-background white content"
        v-if="!damageScreen && !checkoutScreen"
      >
        <v-container class="selfie-content">
          <v-layout class="title pb-1"> Tire uma selfie </v-layout>
          <v-layout justify-center align-center class="mt-8">
            <img
              :src="require(`@/assets/car-sides/newSelfie.png`)"
              alt="selfie"
            />
          </v-layout>
          <v-layout pt-3 justify-center align-center>
            <!--android input Selfie-->
            <v-btn
              v-if="identifyAndroid()"
              class="selfie-button"
              text
              :disabled="confirmSelfie"
              @click="capture(stepContent[0])"
            >
              <span v-if="!confirmSelfie">
                <v-icon>mdi-camera</v-icon>TIRAR FOTO
              </span>

              <span v-else>
                <v-icon size="60" color="success">done_outline</v-icon>
              </span>
            </v-btn>

            <!--Desktop input Selfie-->
            <v-file-input
              v-else
              accept="image/*"
              label="Selfie"
              max-width="200px"
              outlined
              @change="onFileSelected"
              prepend-icon="mdi-camera"
              @click="e1 = 0"
            ></v-file-input>
          </v-layout>
          <div class="text-center finish-button">
            <!--Finalizar-->
            <v-btn
              :disabled="!confirmSelfie"
              color="var(--secondary-color)"
              width="90%"
              class="white--text font-weight-bold"
              @click="newRegister()"
              >FINALIZAR CHECK-IN
            </v-btn>
          </div>
        </v-container>
      </div>
    </div>

    <dadosBancarios
      :show="modalDadosBanco"
      @close="modalDadosBanco = false"
      @setDataAccoutUser="setDataAccoutUser($event)"
      @snackbar="alert('Preencha todos os campos', 'error')"
    ></dadosBancarios>
    <v-dialog v-model="enviandoSelfie" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Aguarde, analisando selfie!
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
function cFile2Blob(cfile, cb) {
  let fr = new FileReader();
  fr.onloadend = (ev) => {
    let b = new Blob([ev.target.result], { type: 'image/jpeg' });
    b.name = cfile.name;
    cb(b);
  };
  fr.readAsArrayBuffer(cfile);
}
import FormAnsweredController from './../../controllers/FormAnsweredController.js';
import VehicleRequestController from './../../controllers/VehicleRequestController.js';
import ModalPadrao from './ModalPadrao.vue';
import ModalFormCheckout from './ModalFormCheckout.vue';
import ConfigurationController from '../../controllers/ConfigurationController.js';
import googleMapsMarkers from './GoogleMapsMarkers.vue';
const Compress = require('compress.js');
import theming from '../../mixins/theming';
import VehicleController from './../../controllers/VehicleController.js';
import DadosBancarios from './ModalDadosBancarios.vue';
import CnhController from '../../controllers/CnhController';
import Constants from '../../models/constants/Constants.js';
import Moment from 'moment';

export default {
  mixins: [theming],
  components: {
    modal: ModalPadrao,
    feedback: ModalFormCheckout,
    googleMapsMarkers,
    dadosBancarios: DadosBancarios,
  },
  data() {
    return {
      confirmSelfie: false,
      damageScreen: true,
      checkoutScreen: false,
      stepColor: [],
      avatarNumbers: [],
      progress: 60,
      stepPhotos: 0,
      notDamaged: true,
      damageMarked: false,
      vehicle: null,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      vehicleController: new VehicleController(this.$resource),
      formAnsweredController: new FormAnsweredController(this.$resource),
      vehicleRequestController: new VehicleRequestController(this.$resource),
      cnhController: new CnhController(this.$resource),
      e1: 1,
      blockNext: true,
      steps: null,
      obs: null,
      stepName: '',
      stepContent: [],
      take: null,
      take_reembolso: false,
      account: null,
      showFinalButton: false,
      vehicleRequestId: this.$route.params.id,
      load_stepContent: false,
      ifCheckOut: false,
      dialogDoors: false,
      modalChaves: false,
      keysCheck: false,
      exitCar: false,
      lockCar: false,
      blockscreen: false,
      feedbackShow: false,
      showMap: false,
      configurationController: new ConfigurationController(this.$resource),
      configurations: {},
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      vehicleRequest: null,
      photoBlob: null,
      modalDadosBanco: false,
      vlr_reembolso: null,
      money: {
        prefix: 'R$ ',
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },
      tentativa: 0,
      quantidadeMinimaTentativas: 0,
      enviandoSelfie: false,
      client_id: localStorage.getItem('client_id'),
      cameraQuality: 30,
      dialogBluetooth: false,
      btnF: false,
      btnT: false,
      btnE: false,
      btnLd: false,
      btnLe: false,
      avatarNumbersF: 0,
      avatarNumbersT: 0,
      avatarNumbersE: 0,
      avatarNumbersLd: 0,
      avatarNumbersLe: 0,
    };
  },

  created() {
    this.scroolTo();
    this.setSteps();
    this.getConfigurations();
  },

  methods: {
    nextScreen() {
      if (this.checkoutScreen) {
        this.exitCar = true;
      } else {
        this.damageScreen = false;
        this.changeProgress(40);
      }
    },
    backScreen() {
      if (this.checkoutScreen) {
        this.$router.push('/');
        //
      } else {
        if (this.progress > 60) {
          this.damageScreen = true;
          this.changeProgress(-40);
        } else {
          this.$router.push('/');
        }
      }
    },
    changeProgress(value) {
      this.progress += value;
    },
    async getConfigurations() {
      let configs = await this.configurationController.getAll(this.client_id);
      this.configurations = configs;
    },
    async checkAnsweredForms() {
      try {
        const currentDate = Moment().locale('pt-br');
        this.answeredForms =
          await this.formAnsweredController.getByVehicleRequestId(
            this.vehicleRequest
          );
        if (this.answeredForms.ok) {
          let result = this.answeredForms.data.filter(function (step) {
            let upload_minutes = currentDate.diff(
              Moment(step.uploaded_at).locale('pt-br'),
              'minutes'
            );
            return upload_minutes < 10;
          });
          this.answeredForms = result;
          this.stepPhotos += result.length;
        }
      } catch (e) {
        console.log(e);
      }
    },

    isAnswered(formId) {
      if (this.answeredForms.length > 0) {
        let stepContent = this.stepContent[formId];
        let form = this.answeredForms.find(
          (form) => form.form_field_id === stepContent.form_field_id
        );
        return form != null;
      } else {
        return false;
      }
    },

    async capture(formField) {
      var index = this.stepContent.indexOf(formField);

      /*if (this.stepColor[index] == true) {
        this.stepPhotos--;
        this.stepColor[index] = false;
        this.avatarNumbers[index] = null;
        formField.check = false;
      } else {*/
        await navigator.camera.getPicture(
          this.onSuccess.bind(this, formField),
          () => {
            formField.check = false;
          },
          {
            quality: this.cameraQuality,
            destinationType: Camera.DestinationType.FILE_URI,
          }
        );
      //}
    },
    openBluetoothPage() {
      this.$router.push({
        path: `/user/reserva/${this.vehicleRequest.vehicle_id}/bluetooth`,
      });
    },

    onSuccess(formField, imageURI) {
      formField.check = true;
      formField.img = imageURI;
      this.uploadAndroid(formField);
    },

    async upload(stepContent) {
      let form = {
        vehicle_request_id: this.vehicleRequestId,
        step_id: this.vehicleRequest.step_id,
        stepContent: stepContent,
        form_field_id: stepContent.form_field_id,
      };

      let data = new FormData();
      data.append('form', JSON.stringify(form));
      return new Promise(
        (resolve, reject) => {
          data.append(
            `formfieldid_${stepContent.form_field_id}`,
            stepContent.img
          );
          if (stepContent.stepName == 'Selfie') {
            this.enviandoSelfie = true;
            this.cnhController
              .compararSelfie(data)
              .then((response) => {
                this.tentativa = this.tentativa + 1;
                if (
                  response.samePerson == 'True' ||
                  this.quantidadeMinimaTentativas == 0
                ) {
                  this.selectedImg = true;
                  this.confirmSelfie = true;
                  this.formAnsweredController
                    .uploadPhotos(data)
                    .then(resolve, reject);
                } else {
                  if (this.tentativa >= this.quantidadeMinimaTentativas) {
                    this.$awn.confirm(
                      'A selfie não corresponde a foto presente na sua CNH, você gostaria de?',
                      () => {
                        (this.confirmSelfie = true),
                          this.formAnsweredController
                            .uploadPhotos(data)
                            .then(resolve, reject);
                      },
                      () => (this.confirmSelfie = false),
                      {
                        labels: {
                          confirmCancel: 'Tirar outra foto',
                          confirmOk: 'Prosseguir C/ check-in',
                        },
                      }
                    );
                  } else {
                    this.alert('Selfie não bate com CNH cadastrada.', 'error');
                  }
                }
              })
              .catch((error) => {
                this.alert(error.body.message, 'error');
              })
              .finally(() => {
                this.enviandoSelfie = false;
              });
          } else {
            this.formAnsweredController
              .uploadPhotos(data)
              .then(resolve, reject);
          }
        },
        (error) => {
          reject(error);
        }
      );
    },

    async uploadAndroid(stepContent) {
      if (stepContent.stepName != 'Selfie') {
        let index = this.stepContent.indexOf(stepContent);
        this.stepPhotos++;
        this.stepColor[index] = true;
        //this.avatarNumbers[index] = this.stepPhotos;
         if(this.btnF == true){
          this.avatarNumbersF++
          this.btnF= false;
        }
        if(this.btnT == true){
          this.avatarNumbersT++
          this.btnT= false;
        }
        if(this.btnE == true){
          this.avatarNumbersE++
          this.btnE= false;
        }
        if(this.btnLd == true){
          this.avatarNumbersLd++
          this.btnLd= false;
        }
        if(this.btnLe == true){
          this.avatarNumbersLe++
          this.btnLe= false;
        }
        this.notDamaged = false;

      }
      let form = {
        vehicle_request_id: this.vehicleRequestId,
        step_id: this.vehicleRequest.step_id,
        stepContent: stepContent,
        form_field_id: stepContent.form_field_id,
      };

      let data = new FormData();
      data.append('form', JSON.stringify(form));
      return new Promise(
        (resolve, reject) => {
          window.resolveLocalFileSystemURL(stepContent.img, (fileEntry) => {
            fileEntry.file((cfile) => {
              cFile2Blob(cfile, (blob) => {
                data.append(`formfieldid_${stepContent.form_field_id}`, blob);
                if (stepContent.stepName == 'Selfie') {
                  this.enviandoSelfie = true;
                  this.cnhController
                    .compararSelfie(data)
                    .then((response) => {
                      this.tentativa = this.tentativa + 1;
                      if (
                        response.samePerson == 'True' ||
                        this.quantidadeMinimaTentativas == 0
                      ) {
                        this.selectedImg = true;
                        this.confirmSelfie = true;
                        this.formAnsweredController
                          .uploadPhotos(data)
                          .then(resolve, reject);
                      } else {
                        if (this.tentativa >= this.quantidadeMinimaTentativas) {
                          this.$awn.confirm(
                            'A selfie não corresponde a foto presente na sua CNH, você gostaria de?',
                            () => {
                              (this.confirmSelfie = true),
                                this.formAnsweredController
                                  .uploadPhotos(data)
                                  .then(resolve, reject);
                            },
                            () => (this.confirmSelfie = false),
                            {
                              labels: {
                                confirmCancel: 'Tirar outra foto',
                                confirmOk: 'Prosseguir C/ check-in',
                              },
                            }
                          );
                        } else {
                          this.alert(
                            'Selfie não bate com CNH cadastrada.',
                            'error'
                          );
                        }
                      }
                    })
                    .catch((error) => {
                      this.alert(error.body.message, 'error');
                    })
                    .finally(() => {
                      this.enviandoSelfie = false;
                    });
                } else {
                  this.formAnsweredController
                    .uploadPhotos(data)
                    .then(resolve, reject);
                }
              });
            });
          });
        },
        (error) => {
          console.error(error);
          reject(error);
        }
      );
    },

    newRegister() {
      if (this.vehicleRequest.step.code == 'check-in') {
        this.blockscreen = true;
        this.formAnsweredController
          .requestCheckIn({ vehicle_request_id: this.vehicleRequestId })
          .then((result) => {
            this.alert(result.message, 'success');
            this.dialogDoors = true;
          })
          .catch((error) => {
            this.alert(error.body.message, 'error');
          })
          .finally(() => (this.blockscreen = false));
      } else if (this.vehicleRequest.step.code == 'check-out') {
        this.blockscreen = true;
        this.formAnsweredController
          .requestCheckOut({ vehicle_request_id: this.vehicleRequestId })
          .then((result) => {
            this.alert(result.message, 'success');
            this.lockCar = true;
          })
          .catch((error) => {
            this.alert(error.body.message, 'error');
          })
          .finally(() => (this.blockscreen = false));
      }
    },

    alert(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    async changeDoors(command) {
      console.log(command, this.vehicleRequest.vehicle_id);
      await this.vehicleController
        .changeStatus(this.vehicleRequest.vehicle_id, command)
        .then((res) => this.alert('Comando enviado!', 'success'))
        .catch((e) => this.alert('Falha ao enviar comando.', 'error'));
      if (
        this.vehicle.bluetooth_mac_address &&
        this.vehicle.bluetooth_device_name
      )
        this.dialogBluetooth = true;
    },

    async onFileSelected(e) {
      this.stepPhotos++;
      let image;
      image = e;

      if (typeof image.name == 'undefined') {
        image = e[0];
      }
      this.notDamaged = false;
      // compactação inicio
      const width = 100;
      const fileName = image.name;
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement('canvas');
          const scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          // img.width and img.height tem as dimensões originais
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              image = file;
              this.stepContent[this.e1].img = image;
              if (this.stepContent[this.e1].stepName == 'Selfie') {
                this.stepPhotos--;
              }

              this.upload(this.stepContent[this.e1]);
            },
            'image/jpeg',
            1
          );
        }),
          (reader.onerror = (error) => console.log(error));
      };
    },
    async setSteps() {
      try {
        this.blockscreen = true;
        let response =
        await this.formAnsweredController.findFormFieldByVehicleRequestId(
          this.vehicleRequestId
        );

        this.stepContent = response.data;
        this.steps = this.stepContent.length;
        this.vehicleRequest = await this.findVehicleRequest();
        await this.checkAnsweredForms(this.vehicleRequest);
        this.vehicle = await this.vehicleController.getVehicleById(
          this.vehicleRequest.vehicle_id
        );
        if (this.vehicleRequest.step.code == 'check-in') {
          this.stepName = 'Check-in';
          //Alterar para true caso ja exista check-out pendente
          this.ifCheckOut = await this.verifyIfExistsCheckout();
        } else if (this.vehicleRequest.step.code == 'check-out') {
          this.stepName = 'Check-out';
          this.take = true;
          this.progress = 25;
          this.checkoutScreen = true;
          this.keysCheck = true;
        }
        this.blockNext = this.ifCheckOut;
        this.load_stepContent = true;
      } catch (err) {
        this.$awn.alert(err.body.message);
      } finally {
        this.blockscreen = false;
      }

    },

    async findVehicleRequest() {
      let response = await this.vehicleRequestController.getVehicleRequestById(
        this.vehicleRequestId
      );
      return response.data;
    },

    async verifyIfExistsCheckout() {
      const availableRequest =
        await this.vehicleRequestController.getVehicleRequestByFilters({
          clientId: localStorage.getItem('client_id'),
          filters: {
            stepCode: 'check-out',
            userId: Number(localStorage.getItem('pickn_user'))
          }
        });

      if (availableRequest.length >= 1) {
        return true;
      } else {
        return false;
      }
    },

    identifyAndroid() {
      if (navigator.userAgent.match(/Android/i)) {
        return true;
      } else {
        return false;
      }
    },

    scroolTo() {
      window.scrollTo(0, 0);
    },

    setDataAccoutUser(item) {
      this.account = item;
    },

    disabledInputReound() {
      if (this.account && this.obs && this.vlr_reembolso) return false;
      return true;
    },
  },
};
</script>

<style scoped>
.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.colorSelectedBack {
  background-color: var(--secondary-color);
}

.sizeTop {
  height: 48px;
}

.vehicleMap {
  position: relative;
  height: 60vh;
}

.check-content {
  min-height: 90vh;
  position: relative;
}

.titleMap {
  padding-top: 70px;
}

.headline {
  padding-top: 80px;
}
.imagem {
  width: auto;
  background-color: transparent;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

.selectImgIcon {
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 70%;
  margin-top: -50px;
}

.steps {
  padding-top: 80px;
}

.footer {
  position: fixed;
  bottom: 56px;
  width: 100%;
}

.choices {
  display: flex;
}

.colorCheckin {
  color: var(--secondary-color) !important;
}

.colorCheckinFundo {
  background-color: var(--primary-color) !important;
}

.colorCheckoutFundo {
  background-color: var(--orange-color) !important;
}

.colorCheckout {
  color: var(--orange-color) !important;
}

.bottom {
  margin-bottom: 100px;
}

.button {
  margin: 0 auto;
}

.cardRadius {
  border-radius: 4px;
}

.colorBtn {
  background-color: var(--secondary-color) !important;
}

.button-text {
  text-transform: none;
}

.radio {
  display: flex;
  justify-items: center;
  align-content: space-between;
}
.hidden {
  visibility: hidden;
}

.awn-btn-success {
  background: var(--primary-color) !important;
  width: 50% !important;
}

.awn-btn-cancel {
  background: white !important;
  color: var(--primary-color) !important;
}
.damage-registry {
  font-size: 14px;
}
.register-content {
  padding-top: 70px;
  min-height: 100vh;
}
.selfie-content {
  padding-top: 70px;
  height: 100vh;
}
.info-container {
  min-height: 400px;
  padding-left: 0;
  padding-top: 26px;
  padding-bottom: 80px;
}
.buttons-container {
  padding-left: 10%;
  padding-top: 16px;
}
.step-header {
  z-index: 3;
  position: fixed;
  padding-top: 20px;
  font-size: 20px;
  font-weight: 700;
  height: 62px;
  width: 100%;
}
.damage-button {
  color: black;
  width: 150px;
  margin: 5px;
  font-weight: 700;
  font-size: 12px;
  font-family: sans-serif;
}
.damage-button-check {
  color: var(--secondary-color);
  width: 150px;
  margin: 5px;
  font-weight: 700;
  font-size: 12px;
  font-family: sans-serif;
}
.damage-switch {
  font-weight: 500;
}
.selfie-button {
  color: var(--secondary-color) !important;
  font-weight: 700;
  font-size: 13px;
}
.finish-button {
  position: absolute;
  bottom: 12%;
  width: 90%;
}
.button-chip {
  color: white;
  position: absolute;
  top: -22px;
  right: 0px;
}
.feedback-screen {
  z-index: 2;
  position: absolute;
}
</style>
